import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  public get(key): string | null {
    return localStorage.getItem(key);
  }

  public set(key, value): void {
    return localStorage.setItem(key, value);
  }

  public remove(key): void {
    return localStorage.removeItem(key);
  }
}
